
import React, { useState, useEffect } from "react";
import "../../CssPage/Currencysettings.css";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import SettingSidebar from "../../components/Setttingsidebar"
import {
    getCurrencySettings,
    updateCurrencySettings,
    getSelectedCurrencies,
    getBaseCurrency
} from "../../services/reactapis";
import { ApiUrl } from "../../Constants/Weburl";
import Layout from "../../components/Layout";
import SettingsPageShell from "../../components/SettingsMenu";
const CURRENCIES = [
    { code: "USD", name: "United States Dollar", symbol: "$", flag: "US" },
    { code: "INR", name: "Indian Rupee", symbol: "₹", flag: "🇮🇳" },
    { code: "EUR", name: "Euro", symbol: "€", flag: "🇪🇺" },
    { code: "GBP", name: "British Pound", symbol: "£", flag: "🇬🇧" },
    { code: "SGD", name: "Singapore Dollar", symbol: "S$", flag: "🇸🇬" },
    { code: "CAD", name: "Canadian Dollar", symbol: "C$", flag: "🇨🇦" },
    { code: "AUD", name: "Australian Dollar", symbol: "A$", flag: "🇦🇺" },
    { code: "JPY", name: "Japanese Yen", symbol: "¥", flag: "🇯🇵" },
];

export default function CurrencySettings() {
   
    const adminToken = localStorage.getItem("adminToken");

    const BASE_CURRENCY = "USD";

    const [defaultCurrency, setDefaultCurrency] = useState("INR");

    const [coinValue, setCoinValue] = useState("0.01");

    const [exchangeRate, setExchangeRate] = useState(null);

    const [loadingRate, setLoadingRate] = useState(false);

    const [rateError, setRateError] = useState("");

    const [displayFormat, setDisplayFormat] = useState("Symbol");

    const [currencyPosition, setCurrencyPosition] =
        useState("Prefix");

    const [activePreview, setActivePreview] =
        useState("USD");


    const [initialLoading, setInitialLoading] = useState(true);

    const [saving, setSaving] = useState(false);

    const [settings, setSettings] = useState(null);

    const [currencies, setCurrencies] = useState([]);

    //basecurrency set state
    const [baseCurrency, setBaseCurrency] = useState(null);


    const [refreshingAll, setRefreshingAll] = useState(false);


    const [currencyDisplayFormat, setCurrencyDisplayFormat] = useState("Symbol");

    const [loading, setLoading] = useState(true);


    // Get selected currency details
    const selectedCurrency =
        currencies.find(
            (item) => item.code === defaultCurrency
        );





    const fetchExchangeRate = async () => {
        if (!baseCurrency) return;
        if (defaultCurrency === baseCurrency.code) {
            setExchangeRate(1);
            return;
        }

        try {
            setLoadingRate(true);
            setRateError("");

            

            const response = await fetch(
                `https://api.exchangerate.dev/v1/latest/${baseCurrency.code}?symbols=${defaultCurrency}`
            );

            if (!response.ok) {
                throw new Error("Unable to fetch exchange rate");
            }

            const data = await response.json();

            console.log("LIVE EXCHANGE RATE:", data);

            const rate = data?.rates?.[defaultCurrency];

            if (!rate) {
                throw new Error("Exchange rate not found");
            }

            setExchangeRate(rate);

        } catch (error) {
            console.log("Exchange rate error:", error);

            setRateError(
                "Unable to fetch exchange rate. Please try again."
            );

            setExchangeRate(null);

        } finally {
            setLoadingRate(false);
        }
    };

    useEffect(() => {

        fetchExchangeRate();

    }, [defaultCurrency, baseCurrency]);

    useEffect(() => {
        fetchSettings();
        fetchSelectedCurrencies();
        fetchBaseCurrency();
    }, []);


   
   
   
    const fetchSettings = async () => {
        try {
            setInitialLoading(true);

            const data = await getCurrencySettings(adminToken);

            if (!data.success) {
                throw new Error(data.message);
            }

            const settingsData = data.data;

            console.log('data fetchsettings', settingsData)

            setSettings(settingsData);

            setDefaultCurrency(settingsData.defaultCurrency);
            // setCoinValue(String(settingsData.coinValue));
            setCoinValue(Number(settingsData.coinValue).toFixed(2));
            setExchangeRate(settingsData.exchangeRate);
            setDisplayFormat(settingsData.displayFormat);
            setCurrencyPosition(settingsData.currencyPosition);

        } catch (error) {
            console.log("fetchSettings error:", error);
        } finally {
            setInitialLoading(false);
        }
    };
    const convertedCoinValue =
        exchangeRate && coinValue
            ? Number(coinValue) * Number(exchangeRate)
            : 0;

    const usd100Value =
        Number(coinValue || 0) * 100;

    const selected100Value =
        Number(coinValue || 0) *
        100 *
        Number(exchangeRate || 0);




    const formatAmount = (currency, amount) => {
        const symbol = currency?.symbol || "";
        const code = currency?.code || "";

        const currencyText =
            displayFormat === "Code" ? code : symbol;

        if (currencyPosition === "Prefix") {
            return `${currencyText}${amount}`;
        }

        return `${amount}${currencyText}`;
    };


    const fetchBaseCurrency = async () => {
        try {
            const data = await getBaseCurrency(adminToken);
            if (data.success && data.data) {
                setBaseCurrency(data.data);
            }
        } catch (error) {
            console.log("fetchBaseCurrency error:", error);
        }
    };


    const handleSave = async () => {
        try {
            setSaving(true);

            const data = await updateCurrencySettings(adminToken, {
                defaultCurrency,
                coinValue: parseFloat(coinValue),
                exchangeRate,
                displayFormat,
                currencyPosition,
            });

            if (!data.success) {
                throw new Error(data.message);
            }

            alert("Settings saved successfully");

        } catch (error) {
            console.log("Save error:", error);
            alert("Failed to save settings");
        } finally {
            setSaving(false);
        }
    };

    const fetchSelectedCurrencies = async () => {
        try {
            const data = await getSelectedCurrencies(adminToken);

            if (data.success) {
                setCurrencies(data.data || []);
            }
        } catch (error) {
            console.log("fetchSelectedCurrencies error:", error);
        }
    };


    const handleRefreshAllRates = async () => {
    try {
        setRefreshingAll(true);

        const response = await fetch(
            `${ApiUrl}api/currencies/refresh-rates`,
            {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${adminToken}`,
                },
            }
        );

        const data = await response.json();

        if (!data.success) {
            throw new Error(data.message);
        }

        alert("Exchange rates updated for all currencies");

        await fetchExchangeRate();

    } catch (error) {
        console.log("Refresh all rates error:", error);
        alert("Failed to update exchange rates");
    } finally {
        setRefreshingAll(false);
    }
};


    return (
             <Layout>
            <SettingsPageShell wrapperClassName="rr-wrapper-currency-page">
               
             
                     {initialLoading ? (
    <div>
      <p>Loading...</p>
    </div>
  ) : (
                    <div className="currency-page">

                        <div className="currency-header">
                            <h1>Currency Settings</h1>

                            <p>
                                Manage your app currency, coin value and exchange rate.
                            </p>
                        </div>

                        {/* Main Card */}
                        <div className="currency-card">

                            {/* Top Row */}
                            <div className="currency-grid">

                                {/* Default Currency */}
                                <div className="field-group">
                                    <label>
                                        Default Currency
                                        <span className="info-icon">i</span>
                                    </label>

                                    <div className="select-wrapper">
                                        <span className="currency-flag">{selectedCurrency?.flag}</span>

                                        <select
                                            // value={baseCurrency}
                                            value={defaultCurrency}
                                            // onChange={(e) =>
                                            //     setBaseCurrency(e.target.value)
                                            // }
                                            onChange={(e) =>
                                                setDefaultCurrency(
                                                    e.target.value
                                                )
                                            }
                                        >
                                            {currencies.map((currency) => (

                                                <option
                                                    key={currency.code}
                                                    value={currency.code}
                                                >
                                                    {currency.code} -{" "}
                                                    {currency.name}
                                                </option>

                                            ))}
                                        </select>

                                        <span className="select-arrow">⌄</span>
                                    </div>

                                    <small>
                                        All coin values are based on this currency.
                                    </small>
                                </div>


                                {/* Coin Value */}
                                <div className="field-group">
                                    <label>
                                        1 Coin Value
                                        <span className="info-icon">i</span>
                                    </label>

                                    <div className="input-with-symbol">
                                        <span>{baseCurrency?.symbol || "$"}</span>

                                        <input
                                            type="number"
                                            // value={coinValue}
                                            // onChange={(e) =>
                                            //     setCoinValue(e.target.value)
                                            // }
                                            // step="0.01"
                                            min="0"
                                            step="0.01"
                                            value={coinValue}
                                            onChange={(e) =>
                                                setCoinValue(
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </div>

                                    <small>
                                        Value of 1 coin in {baseCurrency?.code || "..."}.
                                    </small>
                                </div>

                            </div>


                            {/* Exchange Rate Section */}
                            {baseCurrency && defaultCurrency !== baseCurrency.code && (

                                <div className="exchange-box">

                                    <div className="exchange-content">

                                        <div className="exchange-icon">
                                            ⇄
                                        </div>

                                        <div className="exchange-main">

                                            <h3>
                                                {baseCurrency?.code} to {defaultCurrency} Exchange Rate
                                                <span className="info-icon">i</span>
                                            </h3>

                                            {/* <p>
                                Set the current exchange rate to convert USD to INR.
                            </p> */}

                                            <p>
                                                Current exchange rate used to
                                                convert{baseCurrency?.code} to{" "}
                                                {defaultCurrency}.
                                            </p>


                                            <div className="exchange-input">
                                                {/* <span>₹</span> */}

                                                <span>
                                                    {selectedCurrency?.symbol}
                                                </span>

                                                {/* <input
                                    type="number"
                                    value={exchangeRate}
                                    onChange={(e) =>
                                        setExchangeRate(e.target.value)
                                    }
                                    step="0.01"
                                /> */}
                                                <input
                                                    type="text"
                                                    value={
                                                        loadingRate
                                                            ? "Loading..."
                                                            // : exchangeRate
                                                            : exchangeRate
                                                                ? exchangeRate
                                                                : ""
                                                    }
                                                    readOnly
                                                />
                                            </div>
                                            {rateError && (

                                                <div className="rate-error">
                                                    {rateError}
                                                </div>

                                            )}
                                        </div>


                                        {/* Calculation */}
                                        <div className="calculation-box">

                                            <div className="calculation-title">
                                                <span className="success-icon">✓</span>
                                                {/* Auto Calculated */}
                                                {loadingRate
                                                    ? "Fetching Rate..."
                                                    : "Auto Calculated"}
                                            </div>

                                            <div className="calculation-text">
                                                {/* 1 Coin&nbsp; = &nbsp; */}
                                                1 Coin ={" "}
                                                <strong>
                                                    {/* ${parseFloat(coinValue || 0).toFixed(2)} */}
                                                    {/* {baseCurrency?.symbol} */}
                                                    {Number(coinValue || 0).toFixed(2)}
                                                </strong>
                                                {""}
                                                {/* ({baseCurrency?.symbol}) */}
                                                {`${displayFormat === "Symbol"
                                                    ? baseCurrency?.symbol || ""
                                                    : baseCurrency?.code || ""
                                                    }`}
                                            </div>

                                            <div className="equals-line">
                                                {/* = &nbsp; */}
                                                = {""}

                                                {/* <strong>
                                    ₹{(
                                        parseFloat(coinValue || 0) *
                                        parseFloat(exchangeRate || 0)
                                    ).toFixed(2)}
                                </strong> */}

                                                {/* <strong>
                                               
                                                {selectedCurrency?.symbol}
                                                {convertedCoinValue.toFixed(4)}
                                            </strong> */}

                                                <strong>
                                                    {formatAmount(
                                                        selectedCurrency,
                                                        convertedCoinValue.toFixed(4)
                                                    )}
                                                </strong>

                                                {/* &nbsp;(INR) */}
                                                {" "}

                                                ({defaultCurrency})
                                            </div>

                                        </div>

                                    </div>


                                    {/* Exchange Footer */}
                                    <div className="exchange-footer">

                                        {/* <span>
                                        Last updated: 29 May 2025, 11:30 AM
                                    </span> */}

                                        <span>
                                            Last updated:{" "}
                                            {settings?.exchangeRateUpdatedAt
                                                ? new Date(settings.exchangeRateUpdatedAt).toLocaleString()
                                                : "Not updated yet"}
                                        </span>

                                        <button className="update-rate-btn" 
                                        // onClick={fetchExchangeRate}
                                         onClick={handleRefreshAllRates}
    disabled={refreshingAll}
                                        >
                                            {/* Update Exchange Rate */}
                                            {refreshingAll ? "Updating..." : "Update Exchange Rate"}
                                            <span>↻</span>
                                        </button>

                                    </div>

                                </div>
                            )}


                            {/* Display Settings */}
                            <div className="display-grid">

                                {/* Currency Display Format */}
                                <div className="display-field">

                                    <label>
                                        Currency Display Format
                                        <span className="info-icon">i</span>
                                    </label>

                                    <p>
                                        Choose how currency will be displayed in the app.
                                    </p>

                                    <div className="custom-select">

                                        <span className="display-circle">
                                            {/* {baseCurrency?.symbol}
                                             */}
                                            {`${displayFormat === "Symbol"
                                                ? baseCurrency?.symbol || ""
                                                : baseCurrency?.code || ""
                                                }10`}
                                        </span>

                                        <div>
                                            <strong>
                                                {/* Symbol */}
                                                {displayFormat}
                                            </strong>

                                            <small>
                                                Show currency symbol (Ex: $10, ₹500)
                                            </small>
                                        </div>

                                        <select
                                            value={displayFormat}
                                            onChange={(e) =>
                                                setDisplayFormat(e.target.value)
                                            }
                                        >
                                            <option value="Symbol">
                                                Symbol
                                            </option>

                                            <option value="Code">
                                                Country Code
                                            </option>
                                        </select>

                                        <span className="select-arrow">
                                            ⌄
                                        </span>

                                    </div>

                                </div>


                                {/* Currency Position */}
                                <div className="display-field">

                                    <label>
                                        Currency Position
                                        <span className="info-icon">i</span>
                                    </label>

                                    <p>
                                        Choose the position of currency symbol.
                                    </p>

                                    <div className="custom-select">

                                        <span className="display-circle position-preview">
                                            {/* $10
                                 */}
                                            {currencyPosition === "Prefix"
                                                ? `${displayFormat === "Symbol"
                                                    ? baseCurrency?.symbol || ""
                                                    : baseCurrency?.code || ""
                                                }10`
                                                : `10${displayFormat === "Symbol"
                                                    ? baseCurrency?.symbol || ""
                                                    : baseCurrency?.code || ""
                                                }`
                                            }
                                        </span>

                                        <div>
                                            <strong>
                                                {/* {currencyPosition} */}
                                            </strong>

                                            {/* <small>
                                    Show symbol before amount
                                    (Example: $10)
                                </small> */}
                                            {/* {currencyPosition ===
                                                "Prefix"
                                                ? `Show symbol before amount Ex: (${baseCurrency?.symbol}10)`
                                                : `Show symbol after amount Ex:(10${baseCurrency?.symbol})`
                                            } */}

                                            {
                                                currencyPosition === "Prefix"
                                                    ? `Show ${displayFormat === "Symbol" ? "symbol" : "code"} before amount Ex: ${displayFormat === "Symbol"
                                                        ? baseCurrency?.symbol || ""
                                                        : baseCurrency?.code || ""
                                                    }10`
                                                    : `Show ${displayFormat === "Symbol" ? "symbol" : "code"} after amount Ex: 10${displayFormat === "Symbol"
                                                        ? baseCurrency?.symbol || ""
                                                        : baseCurrency?.code || ""
                                                    }`
                                            }
                                        </div>

                                        <select
                                            value={currencyPosition}
                                            onChange={(e) =>
                                                setCurrencyPosition(e.target.value)
                                            }
                                        >
                                            <option value="Prefix">
                                                Prefix
                                            </option>

                                            <option value="Suffix">
                                                Suffix
                                            </option>
                                        </select>

                                        <span className="select-arrow">
                                            ⌄
                                        </span>

                                    </div>

                                </div>

                            </div>


                            {/* Preview */}
                            <div className="preview-section">

                                <div className="preview-header">

                                    <div>
                                        <h3>
                                            Preview
                                            <span className="info-icon">i</span>
                                        </h3>

                                        <p>
                                            This is how amounts will appear in your app.
                                        </p>
                                    </div>

                                    <div className="preview-tabs">

                                        {/* <button className="active">
                                USD
                            </button> */}

                                        <button
                                            className={
                                                activePreview === "USD"
                                                    ? "active"
                                                    : ""
                                            }
                                            onClick={() =>
                                                setActivePreview("USD")
                                            }
                                        >
                                            USD
                                        </button>

                                        {/* <button>
                                INR
                            </button> */}

                                        <button
                                            className={
                                                activePreview ===
                                                    // defaultCurrency
                                                    baseCurrency?.code
                                                    ? "active"
                                                    : ""
                                            }
                                            onClick={() =>
                                                setActivePreview(
                                                    // defaultCurrency
                                                    baseCurrency?.code
                                                )
                                            }
                                        >
                                            {/* {defaultCurrency} */}
                                            {baseCurrency?.code}
                                        </button>

                                    </div>

                                </div>


                                <div className="preview-cards">

                                    {/* USD */}
                                    <div className="preview-card">

                                        <span>1 Coins</span>

                                        {/* <strong>
                                            ${Number(coinValue || 0).toFixed(2)}
                                        </strong> */}

                                        <strong>
                                            {formatAmount(
                                                { symbol: baseCurrency?.symbol, code: baseCurrency?.code },
                                                (Number(coinValue || 0)).toFixed(2)
                                            )}
                                        </strong>

                                    </div>


                                    {/* INR */}
                                    <div className="preview-card">

                                        <span>1 Coins</span>

                                        {/* <strong>
                                            {selectedCurrency?.symbol}
                                            {convertedCoinValue.toFixed(4)}
                                        </strong>
                                    </div> */}

                                        <strong>
                                            {formatAmount(
                                                selectedCurrency,
                                                convertedCoinValue.toFixed(4)
                                            )}
                                        </strong>

                                    </div>

                                </div>


                                {/* Bottom Buttons */}
                                <div className="action-buttons">

                                    <button className="cancel-btn">
                                        Cancel
                                    </button>

                                    <button
                                        className="save-btn"
                                        onClick={handleSave}
                                    >
                                        <span>▣</span>
                                        Save Settings
                                    </button>

                                </div>

                            </div>
                        </div>

                    </div>
  )}

                {/* </div> */}
                </SettingsPageShell>
          </Layout>
        // </div>

    );
}